import React from 'react';
import { Grid } from '@material-ui/core';

import css from './NavigationItems.module.css';
import NavigationItem from './NavigationItem/NavigationItem';

const NavigationItems = () => (
    <nav className={css.NavigationItems}>
        <Grid container direction="row">
            <NavigationItem link='/' exact>Početna</NavigationItem>
            <NavigationItem link='/tipovi' exact>Tipovi</NavigationItem>
            <NavigationItem link='/kontakt' exact>Kontakt</NavigationItem>
        </Grid>
    </nav>
);

export default NavigationItems;